import Input from '@anm/components/form/Input';
import { FC } from 'react';

import { ButtonsWrapper, ModalTitle, ModalWrapper } from '../ConnectToFacebookModal/Wrapper';

import { FieldlWrapper, FormWrapper, SubmitButton } from './Wrapper';
import useCustomRTMP from '../hooks/useCustomRTMP';

type CustomRTMPModalProps = {
  onModalClose: () => void;
};

const CustomRTMPModal: FC<CustomRTMPModalProps> = ({ onModalClose }) => {
  const [customRTMP, handleBlur, isPending, invalidFields, handleSubmit, handleFieldChange] = useCustomRTMP({
    onModalClose
  });

  return (
    <ModalWrapper {...{ onModalClose }}>
      <ModalTitle title="Setup custom RTMP destination" />
      <FormWrapper>
        <FieldlWrapper>
          <label>
            <span>Name</span>
            <Input
              value={customRTMP.name}
              variant="simple"
              hasError={invalidFields?.includes('name')}
              onBlur={handleBlur}
              onChange={({ target: { value } }) => handleFieldChange({ value, field: 'name' })}
            />
          </label>
        </FieldlWrapper>
        <FieldlWrapper>
          <label>
            <span>Server URL</span>
            <Input
              value={customRTMP.serverUrl}
              variant="simple"
              name="serverUrl"
              hasError={invalidFields?.includes('serverUrl')}
              onBlur={handleBlur}
              onChange={({ target: { value } }) => handleFieldChange({ value, field: 'serverUrl' })}
            />
          </label>
        </FieldlWrapper>

        <FieldlWrapper>
          <label>
            <span>Stream Key</span>
            <Input
              value={customRTMP.streamKey}
              variant="simple"
              name="streamKey"
              hasError={invalidFields?.includes('streamKey')}
              onBlur={handleBlur}
              onChange={({ target: { value } }) => handleFieldChange({ value, field: 'streamKey' })}
            />
          </label>
        </FieldlWrapper>
      </FormWrapper>

      <ButtonsWrapper>
        <SubmitButton variant="light-blue" size="medium" onClick={handleSubmit} isPending={isPending}>
          Add RTMP server
        </SubmitButton>
      </ButtonsWrapper>
    </ModalWrapper>
  );
};

export default CustomRTMPModal;
